import React, { useState } from 'react';
import { uploadJsonToIPFS } from '../utils/ipfsClient';

function IPFSUpload({ jsonData, onClose, isEncrypted = false }) {
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const [error, setError] = useState('');

  const handleUpload = async () => {
    try {
      setUploading(true);
      setError('');
      
      // Upload to IPFS
      const result = await uploadJsonToIPFS(jsonData);
      setUploadResult(result);
    } catch (err) {
      setError(`Upload failed: ${err.message}`);
      console.error('IPFS upload error:', err);
    } finally {
      setUploading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        alert('Copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2>{isEncrypted ? 'Upload Encrypted JSON to IPFS' : 'Upload JSON to IPFS'}</h2>
      </div>
      <div className="card-body">
        {!uploadResult ? (
          <>
            <p className="mb-4">
              {isEncrypted 
                ? 'Your encrypted JSON data will be permanently stored on IPFS.' 
                : 'Your JSON data will be permanently stored on IPFS. Anyone with the CID can access this data.'}
            </p>
            
            <div className="data-preview">
              <h3>Data Preview:</h3>
              <pre className="json-preview">
                {typeof jsonData === 'string' 
                  ? (jsonData.length > 500 ? jsonData.substring(0, 500) + '...' : jsonData)
                  : JSON.stringify(jsonData, null, 2).substring(0, 500) + '...'}
              </pre>
            </div>
            
            {error && <div className="error-message mt-3">{error}</div>}
            
            <div className="button-group mt-4">
              <button 
                type="button" 
                className="btn btn-secondary mr-3"
                onClick={onClose}
              >
                Cancel
              </button>
              <button 
                type="button" 
                className="btn btn-primary"
                onClick={handleUpload}
                disabled={uploading}
              >
                {uploading ? 'Uploading...' : 'Upload to IPFS'}
              </button>
            </div>
          </>
        ) : (
          <div className="upload-success">
            <h3 className="success-title">Upload Successful!</h3>
            
            <div className="result-item">
              <span className="result-label">IPFS CID:</span>
              <span className="result-value">{uploadResult.path}</span>
              <button 
                className="copy-btn"
                onClick={() => copyToClipboard(uploadResult.path)}
              >
                Copy
              </button>
            </div>
            
            <div className="result-item">
              <span className="result-label">Gateway URL:</span>
              <span className="result-value">{uploadResult.url}</span>
              <button 
                className="copy-btn"
                onClick={() => copyToClipboard(uploadResult.url)}
              >
                Copy
              </button>
            </div>
            
            <div className="mt-4">
              <a 
                href={uploadResult.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary mr-3"
              >
                View on IPFS
              </a>
              <button 
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default IPFSUpload;